import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import { formatCurrency } from "../../utils/currency";

const TIPOS_INMUEBLE = [
  { value: "CASA", label: "Casa" },
  { value: "APARTAMENTO", label: "Apartamento" },
  { value: "LOCAL", label: "Local" },
  { value: "OTRO", label: "Otro" },
];

// const TIPOS_MUEBLE = [
//   { value: "VEHICULO", label: "Vehículo" },
//   { value: "MOTOCICLETA", label: "Motocicleta" },
//   { value: "OTRO", label: "Otro" },
// ];

function EditBienModal({ open, onClose, onSubmit, bien }) {
  const [formData, setFormData] = useState({
    tipo_bien: "",
    tipo_inmueble: "",
    direccion: "",
    matricula_inmobiliaria: "",
    tipo_mueble: "",
    placa: "",
    marca: "",
    modelo: "",
    color: "",
    avaluo_catastral: "",
    avaluo_catastralFormatted: "",
    afectaciones: "",
  });

  // Cargar datos del bien cuando el modal se abre
  useEffect(() => {
    if (bien && open) {
      setFormData({
        ...bien,
        avaluo_catastralFormatted: formatCurrency(bien.avaluo_catastral).formatted,
      });
    }
  }, [bien, open]);

  const handleChange = (field) => (event) => {
    let value = event.target.value;
    if (field === "placa") {
      value = value.replace(/\s/g, "");
    }
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMoneyChange = (field) => (event) => {
    const { formatted, value } = formatCurrency(event.target.value);
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      [`${field}Formatted`]: formatted,
    }));
  };

  const handleSubmit = () => {
    const bienActualizado = {
      ...bien,
      ...formData,
      avaluo_catastral: formData.avaluo_catastral.toString(),
    };

    onSubmit(bienActualizado);
    onClose();
  };

  const isInmueble = formData.tipo_bien === "INMUEBLE";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <SuiTypography variant="h5">
          Editar {isInmueble ? "Bien Inmueble" : "Bien Mueble"}
        </SuiTypography>
      </DialogTitle>
      <DialogContent>
        <SuiBox py={3}>
          {formData.tipo_bien === "INMUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Tipo Inmueble
                  </SuiTypography>
                  <Select value={formData.tipo_inmueble} onChange={handleChange("tipo_inmueble")}>
                    {TIPOS_INMUEBLE.map((tipo) => (
                      <MenuItem key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </MenuItem>
                    ))}
                  </Select>
                </SuiBox>
              </Grid>
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Avalúo Catastral
                  </SuiTypography>
                  <SuiInput
                    value={formData.avaluo_catastralFormatted}
                    onChange={handleMoneyChange("avaluo_catastral")}
                  />
                </SuiBox>
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "INMUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Dirección
                  </SuiTypography>
                  <SuiInput value={formData.direccion} onChange={handleChange("direccion")} />
                </SuiBox>
              </Grid>
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Matrícula Inmobiliaria
                  </SuiTypography>
                  <SuiInput
                    value={formData.matricula_inmobiliaria}
                    onChange={handleChange("matricula_inmobiliaria")}
                  />
                </SuiBox>
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "MUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Tipo Mueble
                  </SuiTypography>
                  <SuiInput value={formData.tipo_mueble} onChange={handleChange("tipo_mueble")} />
                  {/* <Select value={formData.tipo_mueble} onChange={handleChange("tipo_mueble")}>
                    {TIPOS_MUEBLE.map((tipo) => (
                      <MenuItem key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </MenuItem>
                    ))}
                  </Select> */}
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Avalúo
                  </SuiTypography>
                  <SuiInput
                    value={formData.avaluo_catastralFormatted}
                    onChange={handleMoneyChange("avaluo_catastral")}
                  />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Modelo
                  </SuiTypography>
                  <SuiInput value={formData.modelo} onChange={handleChange("modelo")} />
                </SuiBox>
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "MUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Marca
                  </SuiTypography>
                  <SuiInput value={formData.marca} onChange={handleChange("marca")} />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Placa
                  </SuiTypography>
                  <SuiInput value={formData.placa} onChange={handleChange("placa")} />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Color
                  </SuiTypography>
                  <SuiInput value={formData.color} onChange={handleChange("color")} />
                </SuiBox>
              </Grid>
            </Grid>
          ) : null}
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiBox mb={2}>
                <SuiTypography variant="h6" fontWeight="light">
                  Afectaciones
                </SuiTypography>
                <SuiInput
                  value={formData.afectaciones}
                  onChange={handleChange("afectaciones")}
                  multiline
                  rows={4}
                />
              </SuiBox>
            </Grid>
          </Grid>
        </SuiBox>
      </DialogContent>
      <DialogActions>
        <SuiButton onClick={onClose} buttonColor="light">
          Cancelar
        </SuiButton>
        <SuiButton onClick={handleSubmit} variant="gradient" buttonColor="dark">
          Guardar Cambios
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}

EditBienModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  bien: PropTypes.shape({
    id: PropTypes.number.isRequired,
    tipo_bien: PropTypes.oneOf(["INMUEBLE", "MUEBLE"]).isRequired,
    tipo_inmueble: PropTypes.string,
    tipo_mueble: PropTypes.string,
    direccion: PropTypes.string,
    matricula_inmobiliaria: PropTypes.string,
    placa: PropTypes.string,
    marca: PropTypes.string,
    modelo: PropTypes.string,
    color: PropTypes.string,
    avaluo_catastral: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    afectaciones: PropTypes.string,
  }).isRequired,
};

export default EditBienModal;
